import { type IDecodedToken } from "@interfaces/auth/IDecodedToken";
import { jwtDecode } from "jwt-decode";

export class TokenUtils {
  private readonly decodedToken: IDecodedToken;

  constructor(accessToken: string) {
    this.decodedToken = jwtDecode<IDecodedToken>(accessToken);
  }

  getUserTenants(): string[] {
    return Object.keys(this.decodedToken.organization ?? {});
  }

  getUserAdmin(): string[] {
    return Object.entries(this.decodedToken.organization ?? {})
      .filter(([, organization]) =>
        organization.groups?.some(
          group => group.replace(/^\/+/, "").toLowerCase() === "administrador"
        )
      )
      .map(([tenantName]) => tenantName);
  }

  getUserRut(): string {
    return this.decodedToken.preferred_username;
  }

  getUserEmail(): string {
    return this.decodedToken.email;
  }

  getUserFirstName(): string {
    return this.decodedToken.given_name;
  }

  getUserLastName(): string {
    return this.decodedToken.family_name;
  }

  getUserFullName(): string {
    return this.decodedToken.name;
  }

  isPlatformAdministrator(): boolean {
    return (
      this.decodedToken.resource_access[
        "oct-operational-admin"
      ]?.roles.includes("oct-platform-admin") ?? false
    );
  }
}
